import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'app-apps-library',
  templateUrl: './apps-library.component.html',
  styleUrls: ['./apps-library.component.scss']
})
export class AppsLibraryComponent {

  isFunctionsActive: boolean = false;

  items = [
    {
      colorClass: "light-blue",
      title: "部落格大綱生成器",
      description: "快速生成吸睛標題與摘要，提升部落格寫作效率",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-yellow",
      title: "部落格主題靈感生成器",
      description: "根據主題聚焦，提供適合目標受眾的部落格題材清單",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-green",
      title: "廣告文案生成器",
      description: "打造高效能、吸引人且具情感共鳴的廣告文案",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-red",
      title: "SEO優化部落格文章撰寫器",
      description: "生成符合搜尋引擎最佳化的優質部落格內容",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-cyan",
      title: "電子郵件主旨優化器",
      description: "基於現有標題，產生多版本電郵主旨，提高開信率",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-purple",
      title: "部落格文章生成器",
      description: "根據標題靈感，分步驟構建大綱、重點與完整內容",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Marketing"]
    },
    {
      colorClass: "light-blue",
      title: "手稿轉部落格工具",
      description: "將學術手稿轉換為淺顯易懂的部落格文章，擴大研究影響力",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-yellow",
      title: "論文標題生成器",
      description: "提供具有吸引力且符合主題的論文標題建議",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Ideation"]
    },
    {
      colorClass: "light-green",
      title: "論點分析工具",
      description: "自動辨識論證中的優勢與不足，協助完善論點",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Critical thinking"]
    },
    {
      colorClass: "light-red",
      title: "反論點生成器",
      description: "生成有力的反駁論述，增強論證說服力",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Critical thinking"]
    },
    {
      colorClass: "light-cyan",
      title: "類比生成器",
      description: "創造有效類比，強化說明與論證效果",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Critical thinking"]
    },
    {
      colorClass: "light-purple",
      title: "批判評價生成器",
      description: "產生針對研究、理論或文章的深入評析",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Critical thinking"]
    },
    {
      colorClass: "light-blue",
      title: "摘要優化器",
      description: "提升學術摘要的表達質量與專業度",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Content"]
    },
    {
      colorClass: "light-yellow",
      title: "範例生成器",
      description: "自動產出輔助說明的實例，提高內容理解度",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Content"]
    },
    {
      colorClass: "light-green",
      title: "結論生成器",
      description: "撰寫簡潔且有力的研究結論段落",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Content"]
    },
    {
      colorClass: "light-red",
      title: "關鍵見解提煉器",
      description: "萃取研究成果中的實用洞見與結論",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Analytics"]
    },
    {
      colorClass: "light-cyan",
      title: "文獻摘要生成器",
      description: "自動匯整與摘要相關學術文獻內容",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Summary"]
    },
    {
      colorClass: "light-purple",
      title: "淺顯語言轉換器",
      description: "將複雜技術語言轉換成易懂的通俗語",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Summary"]
    },
    {
      colorClass: "light-blue",
      title: "引文推廣助理",
      description: "產出可用於社群媒體的研究推廣內容，提升曝光率",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Visibility"]
    },
    {
      colorClass: "light-yellow",
      title: "關鍵字生成器",
      description: "自動擷取文件中的關鍵詞，優化內容搜尋與發現",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Visibility"]
    },
    {
      colorClass: "light-green",
      title: "客戶評論回覆生成器",
      description: "協助撰寫顧客評論回應，有效回應顧客意見，提升品牌形象與互動率",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Support"]
    },
    {
      colorClass: "light-red",
      title: "手稿新聞稿生成器",
      description: "依據手稿撰寫吸引人的媒體新聞稿",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-cyan",
      title: "LinkedIn貼文生成器",
      description: "將研究內容轉換成專業且精簡的LinkedIn動態",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-purple",
      title: "海報大綱生成器",
      description: "創建結構化海報設計大綱，方便學術展示",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-blue",
      title: "影音腳本大綱生成器",
      description: "撰寫吸引人的影音介紹腳本",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-yellow",
      title: "ResearchGate內容摘要生成器",
      description: "精煉手稿內容，提升ResearchGate學術能見度",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-green",
      title: "投稿信生成器",
      description: "根據摘要快速生成具說服力的投稿信",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-red",
      title: "摘要推文生成器",
      description: "製作適合Twitter分享的簡短摘要內容",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-cyan",
      title: "投稿信Instagram貼文生成器",
      description: "將投稿信內容轉化為吸睛的Instagram貼文",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-purple",
      title: "研究者檔案摘要生成器",
      description: "從研究者檔案內容中，精準整理並概括研究者的職涯經歷",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["Academic", "Impact"]
    },
    {
      colorClass: "light-blue",
      title: "感謝信生成器",
      description: "幫您撰寫真摯動人的感謝信",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Communication"]
    },
    {
      colorClass: "light-yellow",
      title: "語氣調整器",
      description: "根據需求自動調整文本語氣風格",
      link: "https://cloud.trinka.ai/ai-apps/",
      category: ["General", "Communication"]
    },
  ];

  selectedFilter = 'All';
  selectedSubFilter: string | null = null;
  originalScrollPosition: number = 0;
  //filteredItems = [...this.items];

  @ViewChild('contentContainer', { static: false }) contentContainer: ElementRef | undefined;

  saveScrollPosition() {
    if (this.contentContainer) {
      this.originalScrollPosition = this.contentContainer.nativeElement.scrollTop;
    }
  }

  filterItems(filter: string) {
    this.selectedFilter = filter;
    this.selectedSubFilter = null;
    if (this.contentContainer) {
      this.contentContainer.nativeElement.scrollTop = this.originalScrollPosition;
    }
  }

  filterSubItems(subFilter: string) {
    this.selectedSubFilter = this.selectedSubFilter === subFilter ? null : subFilter;
  }
  
  isSubFilterActive(subFilter: string): boolean {
    return this.selectedSubFilter === subFilter;
  }

  get filteredItems() {
    return this.items.filter(item =>
      (this.selectedFilter === 'All' || item.category.includes(this.selectedFilter)) &&
      (!this.selectedSubFilter || item.category.includes(this.selectedSubFilter))
    );
  }

  toggleSubFilter() {
    this.isFunctionsActive = !this.isFunctionsActive;
  }

  closeFunctionsMenu(): void {
    this.isFunctionsActive = false;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    const target = event.target as HTMLElement;
    const isInsideMenu = target.closest('.sub-menu-filter, .md-function-btn');
    if (!isInsideMenu) {
      this.closeFunctionsMenu();
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

}
